var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"mm"}),_c('div',{staticClass:"banner-img"},[_c('img',{attrs:{"src":_vm.img}})]),_c('div',{staticClass:"banner-title"},[_c('p',[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }